import React, { useState, useEffect } from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { restrictionConfig } from "../constants/restrictionConfig";

const RestrictedRoute = ({ children }) => {
  const location = useLocation();

  if (restrictionConfig.isApplicationPaused) {
    // Redirect to home and pass state to show the modal
    return <Navigate to="/" replace state={{ showRestriction: true, from: location.pathname }} />;
  }

  return children ? children : <Outlet />;
};

export default RestrictedRoute;
